import { createFileRoute, redirect } from "@tanstack/react-router"

import { AddCompanyForm } from "@/components/company/partners/AddCompanyForm"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"

export const Route = createFileRoute("/_dashboard/partners/companies/add")({
  component: RouteComponent,
  beforeLoad: ({ context: { hasPermissions } }) => {
    if (!hasPermissions(["customer.add_company"])) {
      throw redirect({ to: "/" })
    }
  },
})

function RouteComponent() {
  const navigate = Route.useNavigate()

  return (
    <div className="@container">
      <div className="grid grid-cols-1 @md:grid-cols-3">
        <Card className="@md:col-span-2">
          <CardHeader>
            <CardTitle>Add Company</CardTitle>
          </CardHeader>
          <CardContent>
            <AddCompanyForm
              onBack={() => navigate({ to: "/partners/companies/manage" })}
              onSuccess={() => navigate({ to: "/partners/companies/manage" })}
            />
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
